import { FC, memo } from 'react';

import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import clsx from 'clsx';

import { Paper } from '../paper/Paper';
import { useStyles } from './AttachmentCard.styles';

export const AttachmentCardSkeleton: FC = memo(() => {
  const styles = useStyles({
    shouldShowPreview: false,
    hasDescription: true,
  });

  return (
    <Paper elevation={24}>
      <div className={styles.wrapper}>
        <div className={clsx(styles.fileIconHolder, styles.previewContainer)}>
          <Skeleton variant="rect" animation="wave" classes={{ root: styles.fileIcon }} />
        </div>

        <div className={styles.shortInfo}>
          <Typography variant="subtitle1" className={styles.primaryText}>
            <Skeleton variant="text" animation="wave" width="90%" height={20} />
          </Typography>

          <Typography variant="body1" className={styles.secondaryText}>
            <Skeleton variant="text" animation="wave" width="70%" height={14} />
          </Typography>
        </div>

        <div className={clsx(styles.actions, 'skeleton')}>
          <Skeleton variant="circle" animation="wave" className={styles.actionButton} />
          <Skeleton variant="circle" animation="wave" className={styles.actionButton} />
          <Skeleton variant="circle" animation="wave" className={styles.actionButton} />
        </div>

        <div className={styles.description}>
          <Typography variant="body1" className={styles.secondaryText}>
            <Skeleton variant="text" animation="wave" height={14} />
          </Typography>
          <Typography variant="body1" className={styles.secondaryText}>
            <Skeleton variant="text" animation="wave" height={14} />
          </Typography>
          <Typography variant="body1" className={styles.secondaryText}>
            <Skeleton variant="text" animation="wave" width="45%" height={14} />
          </Typography>
        </div>
      </div>
    </Paper>
  );
});
